export type ConfidenceBand = 'high' | 'medium' | 'low';

export const HIGH_CONFIDENCE_PERCENT = 80;
export const MEDIUM_CONFIDENCE_PERCENT = 40;

export const confidenceBand = (percent: number): ConfidenceBand => {
  if (percent >= HIGH_CONFIDENCE_PERCENT) return 'high';
  return percent >= MEDIUM_CONFIDENCE_PERCENT ? 'medium' : 'low';
};

export const scoreToPercent = (score: number): number => Math.round(Math.min(Math.max(score, 0), 1) * 100);

export interface ConfidenceExplanation {
  summary: string;
  bands: Record<ConfidenceBand, string>;
}

export const PERCENT_BAND_RANGES: Record<ConfidenceBand, string> = {
  high: `${HIGH_CONFIDENCE_PERCENT}% and up`,
  medium: `${MEDIUM_CONFIDENCE_PERCENT}–${HIGH_CONFIDENCE_PERCENT - 1}%`,
  low: `Under ${MEDIUM_CONFIDENCE_PERCENT}%`,
};

export const IMAGE_MATCH_CONFIDENCE: ConfidenceExplanation = {
  summary: 'How strongly the photos point to this part.',
  bands: {
    high: 'An NSN or part number read clearly off the photos matches it.',
    medium:
      'A match, but the identifier was hard to read, only suggested by the model, or the item type differs. Check it.',
    low: 'The same kind of part. Nothing in the photos identifies it.',
  },
};

export const SOURCING_CONFIDENCE: ConfidenceExplanation = {
  summary: 'How likely this supplier can sell you this exact part.',
  bands: {
    high: 'The part is listed for sale, or a CAGE-coded supplier is tied to this NSN or part number.',
    medium: 'A lead worth a quote request: a matching part or a relevant supplier, without proof they stock it.',
    low: 'A weak lead.',
  },
};

export const LABEL_READING_CONFIDENCE: ConfidenceExplanation = {
  summary: 'How clearly this field was read off the label.',
  bands: {
    high: 'Every character is clear.',
    medium: 'Some characters could be read two ways. Compare it with the label crop.',
    low: 'Glare, blur, or damage. Treat it as a guess.',
  },
};
